import React from "react";
import { useT } from "@/i18n/lang";

export default function Marquee() {
  const { t } = useT();
  const items = [
    t("marquee.1"), t("marquee.2"), t("marquee.3"), t("marquee.4"),
    t("marquee.5"), t("marquee.6"), t("marquee.7"),
  ];
  const tripled = [...items, ...items, ...items];
  return (
    <div data-testid="marquee" className="bg-[#0A0A0A] py-4 overflow-hidden border-y border-[#0A0A0A]">
      <div className="marquee-track flex whitespace-nowrap">
        {tripled.map((it, i) => (
          <span key={i} className="text-white font-display font-bold tracking-[0.2em] text-xs md:text-sm uppercase mx-8 inline-flex items-center">
            {it}
            <span className="ml-8 w-1.5 h-1.5 bg-[#EB0A1E]" />
          </span>
        ))}
      </div>
    </div>
  );
}
